module.exports = __webpack_public_path__ + "img/Weapon_69.50742b55.png";